let requestList = []; // api请求记录
let filterUrlMap = new Map();
filterUrlMap.set('/application/model/getModelFormReportList', '/application/model/getModelFormReportList');
filterUrlMap.set('/cs/user/getUserList', '/cs/user/getUserList');// 用户
filterUrlMap.set('/component/customForm/saveCalculation', '/component/customForm/saveCalculation');
filterUrlMap.set('/process/businessTree/getBusinessTreeList', '/process/businessTree/getBusinessTreeList');// 业务分类
filterUrlMap.set('/component/serialNumber/getSerialNumberTreeList', '/component/serialNumber/getSerialNumberTreeList');// 流水号
filterUrlMap.set('/system/department/getDepartmentTreeList', '/system/department/getDepartmentTreeList');// 部门
filterUrlMap.set('/component/dictionary/getDictionaryTreeList', '/component/dictionary/getDictionaryTreeList');// 数据字典
filterUrlMap.set('/process/task/uploadFile', '/process/task/uploadFile');
filterUrlMap.set('/process/processInstance/uploadFile', '/process/processInstance/uploadFile');
filterUrlMap.set('/document/publicLibrary/uploadFile', '/document/publicLibrary/uploadFile');
filterUrlMap.set('/document/archiveTemplate/uploadFile', '/document/archiveTemplate/uploadFile');
filterUrlMap.set('/upload/file/sample', '/upload/file/sample');
filterUrlMap.set('/component/customForm/getFormConfigs', '/component/customForm/getFormConfigs');
filterUrlMap.set('/approval/instance/getApprovalRecordList', '/approval/instance/getApprovalRecordList');
filterUrlMap.set('/process/processInstance/getComments', '/process/processInstance/getComments');
filterUrlMap.set('/document/archiveTemplateTree/getArchiveTemplateTreeList', '/document/archiveTemplateTree/getArchiveTemplateTreeList');
// filterUrlMap.set('/operation/state/getProcessTimeTreeList', '/operation/state/getProcessTimeTreeList');
filterUrlMap.set('/cs/user/getLoginUser', '/cs/user/getLoginUser');// 登录
filterUrlMap.set('/application/model/getPublishedApplicationList', '/application/model/getPublishedApplicationList');// getPublishedApplicationList
filterUrlMap.set('/cs/user/getUseWorkPlantEntry', '/cs/user/getUseWorkPlantEntry');
filterUrlMap.set('/component/customForm/getFormDashBoardData', '/component/customForm/getFormDashBoardData');// BI
filterUrlMap.set('/component/customForm/getFormFieldstatistics', '/component/customForm/getFormFieldstatistics');// 仪表盘-统计项
filterUrlMap.set('/component/customForm/getFormFieldstatisticsGroup', '/component/customForm/getFormFieldstatisticsGroup');// 仪表盘分组统计
filterUrlMap.set('/approval/template/getApprovalTemplateList', '/approval/template/getApprovalTemplateList');// 仪表盘-快捷入口审批流
filterUrlMap.set('/process/processService/getPublishedProcessLists', '/process/processService/getPublishedProcessLists');// 仪表盘-快捷入口业务流
filterUrlMap.set('/component/customForm/getBIFormConfigs', '/component/customForm/getBIFormConfigs');// 仪表盘-快捷入口业务流
filterUrlMap.set('/application/model/getApplicationModelTreeList', '/application/model/getApplicationModelTreeList');// 仪表盘-快捷入口业务流
filterUrlMap.set('/component/customForm/getProgressBarList', '/component/customForm/getProgressBarList');// 仪表盘-进度条
filterUrlMap.set('/component/customForm/getDataProgressBarList', '/component/customForm/getDataProgressBarList');// 仪表盘-进度条
filterUrlMap.set('/component/customForm/getFormWarehousing', '/component/customForm/getFormWarehousing');// 仪表盘-配置
filterUrlMap.set('/system/employee/getUserExtendDataIds', '/system/employee/getUserExtendDataIds');// 获取人员扩展字段
filterUrlMap.set('/application/model/getModelServiceList', '/application/model/getModelServiceList');// 模型详情
filterUrlMap.set('/application/model/saveAppModelForm', '/application/model/saveAppModelForm');// 模型详情
filterUrlMap.set('/application/model/getTableColumnsByFormId', '/application/model/getTableColumnsByFormId');// 模型详情
filterUrlMap.set('/application/model/getFormColumnsByFormId', '/application/model/getFormColumnsByFormId');// 模型详情
filterUrlMap.set('/process/task/getProcessTaskList', '/process/task/getProcessTaskList');// 模型详情
filterUrlMap.set('/process/task/getProcessTask', '/process/task/getProcessTask');// 任务详情
filterUrlMap.set('/application/model/getModelFormInstanceById', '/application/model/getModelFormInstanceById');// 根据Id查询数据详情
filterUrlMap.set('/process/processInstance/getProcessCurrentTasks', '/process/processInstance/getProcessCurrentTasks');// 根据Id查询数据详情
filterUrlMap.set('/process/processInstance/getProcessAllFormInstances', '/process/processInstance/getProcessAllFormInstances');// 根据Id查询数据详情
/**
 * 将当前请求记录到缓存中
 * @param {*} key
 */
export const add = (config, funcCancel) => {
    if (!config) {
        return false;
    }

    let req = genReq(config);
    for (let index = 0, len = requestList.length; index < len; index++) {
        // TODO: modified by hezhen 20190311 进行过滤处理，因为有的页面发起相同的请求得不到数据受到影响，后续需要改正
        if (!filterUrlMap.has(config.url) && req === requestList[index].req) {
            requestList[index].funcCancel();
            // requestList.splice(index, 1); // 把这条记录从数组中移除
            // console.log('cancel request:', config.url);
            return;
        }
    }

    requestList.push({
        req: genReq(config),
        funcCancel
    });
};

// 将请求完成的api从记录中移除
export const remove = (config) => {
    if (!config) {
        return false;
    }
    let req = genReq(config);
    for (let index = 0, len = requestList.length; index < len; index++) {
        if (req === requestList[index].req) {
            requestList.splice(index, 1); // 把这条记录从数组中移除
            break;
        }
    }
};

// 当前请求的api是否已有记录
export const has = (config) => {
    if (!config) {
        return false;
    }
    let req = genReq(config);
    for (let index = 0, len = requestList.length; index < len; index++) {
        if (req === requestList[index].req) {
            return true;
        }
    }
    return false;
};

/**
 * 生成请求记录对象，方面对比
 * @param {object} config 请求对象
 */
const genReq = (config) => {
    if (!config) {
        return '';
    }
    let arrayReq = [];
    arrayReq.push(`url:${config.url},`);
    arrayReq.push(`method:${config.method},`);
    arrayReq.push(`params:${json2Form(config.params)},`);
    arrayReq.push(`header:${json2Form(config.header)}`);
    // let key = 'Method: ' + config.method + ',Url: ' + url + ',Data: ' + json2Form(data) + ', header:' + json2Form(header);
    return arrayReq.join('');
};

const json2Form = (json) => {
    var str = [];
    for (var key in json) {
        if (key !== 't') {
            str.push(encodeURIComponent(key) + '=' + encodeURIComponent(json[key]));
        }
    }
    return str.join('&');
};



// WEBPACK FOOTER //
// ./src/utils/http/request-record.js